// language=GraphQL
export const ALL_BUS_SETTINGS_QUERY = `query Query {
  busSettings: allTravelServiceBusSettings {
    id
    boardingSelectionEnabled
  }
}`

// language=GraphQL
export const SINGLE_BUS_SETTINGS_QUERY = `query Query($id: ID!) {
  busSettings: travelServiceBusSettings(id: $id) {
    id
    boardingSelectionEnabled
  }
}`

// language=GraphQL
export const CREATE_BUS_SETTINGS_MUTATION = `
  mutation Mutation($input: CreateTravelServiceBusSettingsInput) {
    busSettings: createTravelServiceBusSettings(input: $input) {
      id
      boardingSelectionEnabled
    }
  }`

// language=GraphQL
export const UPDATE_BUS_SETTINGS_MUTATION = `
  mutation Mutation($input: UpdateTravelServiceBusSettingsInput) {
    busSettings: updateTravelServiceBusSettings(input: $input) {
      id
      boardingSelectionEnabled
    }
  }`

// language=GraphQL
export const DELETE_BUS_SETTINGS_MUTATION = `
  mutation Mutation($input: DeleteTravelServiceBusSettingsInput) {
    deleteTravelServiceBusSettings(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_BUS_SETTINGS_MUTATION = `
  mutation Mutation($input: DeleteTravelServiceBusSettingsInput) {
    forceDeleteTravelServiceBusSettings(input: $input) {
      success
    }
  }`
// language=GraphQL
export const BUS_SETTINGS_DEPENDENTS_QUERY = `query Query($id: ID!, $withTravelPricingMandatorySettings: Boolean = false) {
  groupedDependents: travelServiceBusSettingsDependents(id: $id) {
    travelPricingMandatorySettings @include(if: $withTravelPricingMandatorySettings) {
      id
      isMandatory
      useRules
      useDateSwitch
      useBusSettings
    }
  }
}`
